import { Component } from '@angular/core';
import { GetCategoryRequest } from './service/models/category.service.model';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
})
export class CategoryComponent {
  filter!: GetCategoryRequest;

  setFilter(filter: GetCategoryRequest) {
    this.filter = filter;
  }
}
